// Esperanto — scroll reveal & hero parallax v2
// fix: scale parallax allineato al CSS (1.05), LCP reveal above-fold
(function(){
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(){
    var els = document.querySelectorAll('.esp-reveal, .esp-stagger');
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function(el){ el.classList.add('in'); });
      return;
    }

    // Elementi above the fold: attivati subito, senza aspettare IO
    els.forEach(function(el){
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        el.classList.add('in');
      }
    });

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    els.forEach(function(el){
      if (!el.classList.contains('in')) { io.observe(el); }
    });

    // Hero parallax — desktop only
    if (!window.matchMedia('(min-width: 980px)').matches) return;
    var img = document.querySelector('.esp-hero-img img');
    if (!img) return;
    var raf;
    // Usa lo stesso valore di scale del CSS (1.05) per evitare micro-salto
    window.addEventListener('scroll', function(){
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function(){
        var y = window.scrollY;
        if (y < 900) img.style.transform = 'scale(1.05) translateY(' + (y * 0.05) + 'px)';
      });
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
